export const ADMINISTRATION_TRANSACTION_PENDING_SIGNATURE = "COR101I";

export const CAPTCHA_REQUIRED = "API021W";

export const CAPTCHA_INVALID = "COR050W";

export const INSUFFICIENT_SIGNATURES = "COR023I";

export const INTERNAL_ERROR = "API516W";

export const SCHEDULED_TRANSACTION = "COR013I";

export const TRANSACTION_FINISHED = "COR000I";

export const UNEXPECTED_ERROR = "COR999E";

export const VALIDATION_ERROR = "COR020W";

export const NOT_AUTHORIZED = "COR005E";

export const INSUFFICIENT_BALANCE = "API544I";
const INSUFFICIENT_BALANCE_LEGACY = "COR111I";
export const FAILED_BY_INSUFFICIENT_BALANCE = "failedByInsufficientBalance";

export const isInsufficientBalance = (code) => code === INSUFFICIENT_BALANCE || code === INSUFFICIENT_BALANCE_LEGACY;

export const isFailedByInsufficientBalance = (data) => Boolean(data?.data?.[FAILED_BY_INSUFFICIENT_BALANCE]);

export const getInsufficientBalanceSnackbar = (data, pendingMessage) => {
    if (isFailedByInsufficientBalance(data)) {
        return {
            message: data?.message || "La cuenta tiene saldo insuficiente para realizar la transacción",
            type: "error",
        };
    }
    return { message: pendingMessage, type: "warning" };
};

export const BACKEND_EXTERNAL_ERROR = "API530W";
